import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMagicBook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMagicBook"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V22H4V2ZM5.5 18V20.5H18.5V18H5.5ZM12.3333 7.33333L13.5 5L14.6667 7.33333L17 8.5L14.6667 9.66667L13.5 12L12.3333 9.66667L10 8.5L12.3333 7.33333ZM9.5 10L8.66667 11.6667L7 12.5L8.66667 13.3333L9.5 15L10.3333 13.3333L12 12.5L10.3333 11.6667L9.5 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMagicBook;
